'use client'

import { useState } from 'react'

import { useRewardRedemptionsByReward } from '../hooks/useRewardRequests'
import { useStoreStore } from '../stores/useStoreStore'

import { Reward } from '@/features/store/types/reward'
import { useModalContext } from '@/shared/contexts/Modal'
import { useStoreAnalytics } from '@/shared/lib/analytics'
import { Button } from '@/shared/ui/Button'
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  CardTile
} from '@/shared/ui/Card'

import { RewardModal } from './RewardModal'
import { RewardRequestBadge } from './RewardRequestBadge'

interface StoreListProps {
  categoryId: number
}

export const StoreList = ({ categoryId }: StoreListProps) => {
  const { rewards, isSuccess } = useStoreStore({ categoryId })
  const { stateByReward } = useRewardRedemptionsByReward()
  const [selectedReward, setSelectedReward] = useState<Reward | null>(null)
  const { openModal } = useModalContext()
  const { trackRewardViewed } = useStoreAnalytics()

  const handleOpenModal = (reward: Reward) => {
    trackRewardViewed(reward)
    openModal({ modal: RewardModal }, { reward })
  }

  const handleCloseModal = () => {
    setSelectedReward(null)
  }

  return (
    <div className="flex flex-col gap-4 w-full items-center">
      <Card>
        <CardHeader>
          <CardTitle>Lojinha</CardTitle>
        </CardHeader>
        <CardBody>
          <div className="flex flex-col gap-4">
            {isSuccess &&
              rewards?.map(reward => {
                const prices = reward.reward_items.map(price => price.coin)
                const maxPrice = Math.max(...prices)
                const minPrice = Math.min(...prices)

                const redemptionState = stateByReward[reward.id]

                return (
                  <div key={reward.id} onClick={() => handleOpenModal(reward)}>
                    <CardTile>
                      <img
                        src={reward?.image?.file?.url || '/misc/pack.png'}
                        alt={reward.name}
                        className="size-15"
                      />
                      <div className="flex flex-col gap-1 min-w-0">
                        <span className="text-lg font-bold text-primary-dark font-sans">
                          {reward.name}
                        </span>
                        {redemptionState && (
                          <RewardRequestBadge state={redemptionState} />
                        )}
                      </div>
                      <div className="ml-auto flex-shrink-0">
                        <Button variant="primary" className="flex items-center gap-1">
                          <img
                            src="/icons/coin.svg"
                            alt="coin"
                            className="size-4"
                          />
                          <span>
                            {minPrice === maxPrice
                              ? minPrice
                              : `${minPrice} - ${maxPrice}`}
                          </span>
                        </Button>
                      </div>
                    </CardTile>
                  </div>
                )
              })}
          </div>
        </CardBody>
      </Card>
      {selectedReward && (
        <RewardModal
          reward={selectedReward}
          open={!!selectedReward}
          onOpenChange={handleCloseModal}
        />
      )}
    </div>
  )
}
